/**
 * ReactionSummary — barre de comptage façon LinkedIn.
 *
 *   [👍 👏 💡]  12          4 commentaires
 *
 * Affiche uniquement les types RÉELLEMENT utilisés (pas de « 0 J'aime »),
 * suivis du total puis du nombre de commentaires. Le détail par type est
 * lisible au survol et par les lecteurs d'écran via l'attribut title.
 *
 * `detailed` (page du post) ajoute le décompte chiffré de chaque type.
 */
import { MessageCircle } from "lucide-react";
import { REACTIONS, emptySummary } from "../lib/reactions";

function plural(n, singular, pluriel) {
  return `${n} ${n > 1 ? pluriel : singular}`;
}

export default function ReactionSummary({
  summary,
  commentsCount = 0,
  detailed = false,
  className = "",
  testid,
}) {
  const { counts, total } = summary || emptySummary();
  const used = REACTIONS.filter((r) => (counts?.[r.type] || 0) > 0);

  if (total === 0 && commentsCount === 0) return null;

  const title = used.length
    ? used.map((r) => `${counts[r.type]} ${r.label}`).join(" · ")
    : undefined;

  return (
    <div
      className={`flex items-center gap-3 text-xs flex-wrap ${className}`}
      style={{ color: "#666" }}
      data-testid={testid || "reaction-summary"}
    >
      {total > 0 && (
        <span className="flex items-center gap-1.5" title={title}>
          <span className="flex items-center -space-x-1">
            {used.map((r) => (
              <span
                key={r.type}
                className="flex items-center justify-center rounded-full"
                style={{
                  width: 18,
                  height: 18,
                  background: "#FFF7ED",
                  border: "1px solid #FFF",
                }}
                data-testid={`reaction-chip-${r.type}`}
              >
                <r.Icon size={10} color="#F77F00" />
              </span>
            ))}
          </span>
          <span className="font-medium" data-testid="reaction-total">
            {total}
          </span>
        </span>
      )}

      {detailed && total > 0 && (
        <span className="flex items-center gap-2 flex-wrap">
          {used.map((r) => (
            <span key={r.type} data-testid={`reaction-detail-${r.type}`}>
              {plural(counts[r.type], r.label, `${r.label}`)}
            </span>
          ))}
        </span>
      )}

      {commentsCount > 0 && (
        <span className="flex items-center gap-1" data-testid="comments-count">
          <MessageCircle size={12} />
          {plural(commentsCount, "commentaire", "commentaires")}
        </span>
      )}
    </div>
  );
}
